{
  // on mobile swap the gallery/content order so the gallery always comes on top
  // a bit weird -- but we need to do this to avoid using flex-reverse/css order/etc so tabindex stays true
  const swapForMobile = () => {
    document.querySelectorAll('.tabbed-alternating-content--row').forEach(row => {
      const gallery = row.querySelector('.col:has(.gallery--wrap)')
      const content = row.querySelector('.col:has(.tabbed-alternating-content--content-panel)')
      if (!gallery || !content) return

      if (window.innerWidth <= 768) {
        if (content.compareDocumentPosition(gallery) & Node.DOCUMENT_POSITION_FOLLOWING) {
          row.insertBefore(gallery, content)
        }
      }
    })
  }
  swapForMobile()

  //handle button clicks
  document.querySelectorAll('.tabbed-alternating-content--filter').forEach(button => {
    button.addEventListener('click', e => {
      e.preventDefault()

      const container = button.closest('.tabbed-alternating-content')
      const label = button.textContent.trim()
      const showAll = label === 'All'

      // Update active state
      container.querySelectorAll('.tabbed-alternating-content--filter').forEach(btn => {
        btn.setAttribute('aria-pressed', btn === button)
      })

      // Show/hide rows
      container.querySelectorAll('[data-category-filter]').forEach(row => {
        const visible = showAll || row.getAttribute('data-category-filter') === label
        row.style.display = visible ? '' : 'none'
      })

      // Focus first focusable element in the first visible row
      window.requestAnimationFrame(() => {
        const firstVisible = [...container.querySelectorAll('[data-category-filter]')].find(row => row.style.display !== 'none')
        firstVisible?.querySelector('a, button, input, [tabindex]')?.focus()
      })
    })
  })
}